import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { SettingsLandingStore } from 'src/stores/SettingsStores/SettingsLandingStore/SettingsLandingStore';

export const LandingPageDetails = observer(() => {
    return (
        <EntityPresentation
            store={SettingsLandingStore}
            entityName="landing-page"
        />
    );
});
